<template>
  <!-- Total: 5+5+5+9+5+6+1 = 36 spans -->
  <div class="cardLayoutWrapper cardLayoutWrapper--header">
    <BasicCell :span="5">
      <span>Référence</span>
    </BasicCell>
    <BasicCell
      :span="5"
      extra-class="elem--clickable elem--sort"
    >
      <BasicSort
        v-model="modelValue"
        name="dateEmission"
      />
      <span>Date de paiement</span>
    </BasicCell>
    <BasicCell :span="5">
      <span>Montant TTC</span>
    </BasicCell>
    <BasicCell :span="9">
      <span>Bénéficiaire</span>
    </BasicCell>
    <BasicCell :span="5">
      <span>Référence Facture</span>
    </BasicCell>
    <BasicCell :span="6">
      <span>Dossier</span>
    </BasicCell>
    <BasicCell :span="1" />
  </div>
</template>

<script setup lang="ts">
  import BasicCell from '@designSystem/components/basic/cell/BasicCell.vue'

  const modelValue = defineModel<string>()
</script>
